import axios from "axios";
axios.defaults.timeout = 20000;

function getUrl() {
    if (/localhost/.test(window.location.host) || /qa./.test(window.location.host)) {
        return `${window.location.protocol}//xwg-admin-qa.zu-ji.com/cms/`;
    }
    return `${window.location.protocol}//admin-api.jsxwg.com/cms/`;
}

function post(url, param) {
    return new Promise((resolve, reject) => {
        let data = {
            method: url.includes("getById") ? "get" : "post",
            url: url
        };
        data[data.method == "get" ? "params" : "data"] = param;
        axios(data)
            .then(res => {
                resolve(res.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

let api = {
    news: "news/queryList",
    newDetail: "news/getById",
    postion: "recruit/queryList",
    postionDetail: "recruit/getById"
};

Object.keys(api).forEach(key => {
    let url = getUrl() + api[key];
    api[key] = function (param) {
        return post(url, param);
    };
});

export default api;
